<div class="tags">
  <a class="tags__tag" (click)="toggleTag(tag)" [ngClass]="{'tags__tag--selected': isSelected(tag.id)}"
    *ngFor="let tag of field.entities">
    <span class="tags__tag__icon ico-success"></span> {{ getTitle(tag) }}</a>
  <swb-no-data *ngIf="!field.entities || field.entities.length === 0"></swb-no-data>
</div>